var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        "z-index": "4",
        height: "100%"
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-delete-img",
          staticStyle: { top: "70px", right: "5px", "z-index": "4" },
          on: { click: _vm.closePdf }
        },
        [_c("i", { staticClass: "icon-close-img" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main-cnt block-image ex-preprocessing" }, [
        _c(
          "figure",
          {
            staticClass: "bill-fig",
            class: { noimage: _vm.url_pdf == "" },
            staticStyle: { border: "0" }
          },
          [
            _vm.loadedRatio > 0 && _vm.loadedRatio < 1
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "background-color": "green",
                      color: "white",
                      "text-align": "center"
                    },
                    style: { width: _vm.loadedRatio * 100 + "%" }
                  },
                  [_vm._v(_vm._s(Math.floor(_vm.loadedRatio * 100)) + "%")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("pdf", {
              ref: "pdf",
              attrs: { src: _vm.url_pdf, page: _vm.page, rotate: _vm.rotate },
              on: {
                progress: function($event) {
                  _vm.loadedRatio = $event
                },
                "num-pages": function($event) {
                  _vm.numPages = $event
                },
                "link-clicked": function($event) {
                  _vm.page = $event
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav-slide-pdf" },
          _vm._l(_vm.numPages, function(pageSelect, index) {
            return _c("span", {
              key: index,
              staticClass: "dot",
              class: { active: pageSelect == _vm.selected },
              on: {
                click: function($event) {
                  return _vm.changePage(pageSelect)
                }
              }
            })
          }),
          0
        ),
        _vm._v(" "),
        false
          ? _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.page,
                    expression: "page",
                    modifiers: { number: true }
                  }
                ],
                staticStyle: { width: "5em" },
                attrs: { type: "number", max: _vm.numPages, min: "1" },
                domProps: { value: _vm.page },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.page = _vm._n($event.target.value)
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              _vm._v(" /" + _vm._s(_vm.numPages) + "\n            "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      _vm.rotate += 90
                    }
                  }
                },
                [_vm._v("⟳")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  on: {
                    click: function($event) {
                      _vm.rotate -= 90
                    }
                  }
                },
                [_vm._v("⟲")]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc19bd80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc19bd80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Voucher/PdfViewer.vue
// module id = null
// module chunks = 